module.exports = __webpack_public_path__ + "img/女-肝癌h.0a2bc260.png";